import * as React from 'react';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import { IHistoryContext, withHistoryContext } from 'Containers/FormContextHandler';
import { isPartialDate } from 'neuro-utils';

const DocumentCreationButtonGenerator = ({
  name,
  text,
  documents,
  startEdit,
  additionalData,
  fm,
}: { name: TDocTypesWithEnddates; text: string } & IHistoryContext<
  TDocumentsWithEnddates,
  IAdditionalData
>): React.JSX.Element => {
  const thisDocTypeDocuments = (documents || [])?.filter(d => d._type === name);

  const notEndedTreatment = thisDocTypeDocuments.find(p => {
    if (name === 'madTherapy') {
      const isTreatmentStarted = (p as IMADTherapy).isTreatmentStarted;
      return !isTreatmentStarted ? false : !isPartialDate(p.endDate);
    } else return !isPartialDate(p.endDate);
  });

  // Retrospective visit reason
  const retro = additionalData?.visitReasonRetro;

  const oxygenTherapyAvailable = (documents: Array<IOxygenTherapy>): boolean => {
    const activeDocs = documents.filter(d => !isPartialDate(d.endDate));
    if (
      activeDocs.some(d =>
        ['oxygenConcentratorTherapeutic', 'oxygenConcentratorPalliative'].includes(d.oxygenTherapyType ?? ''),
      ) &&
      activeDocs.some(d => d.oxygenTherapyType === 'stressOxygen')
    ) {
      return false;
    }
    return true;
  };

  const disabled =
    !retro && (name === 'oxygenTherapy' ? !oxygenTherapyAvailable(documents as IOxygenTherapy[]) : !!notEndedTreatment);

  return (
    <DocumentCreationButton
      name={name}
      text={text}
      onClick={startEdit && startEdit({}, name)}
      width={15}
      height={3}
      fontSize={14}
      alternate={true}
      disabled={disabled}
      disabledTooltip={<>{fm('treatment.endOngoingToAddNew')}</>}
    />
  );
};

type TDocTypesWithEnddates =
  | 'oxygenTherapy'
  | 'hfncTherapy'
  | 'papTherapy'
  | 'madTherapy'
  | 'patientDoesNotWantRespiratorySupportTherapy';

type TDocumentsWithEnddates =
  | IPAPTherapy
  | IHFNCTherapy
  | IOxygenTherapy
  | IMADTherapy
  | IPatientDoesNotWantRespiratorySupportTherapy;

interface IAdditionalData {
  visitReasonRetro?: boolean;
}

export const DocumentCreationButtonWithContext = withHistoryContext(DocumentCreationButtonGenerator);
